import { initializeApp } from 'firebase/app';
import {
  getAuth,
  connectAuthEmulator,
  GoogleAuthProvider,
  OAuthProvider,
  onIdTokenChanged,
} from 'firebase/auth';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

const emulatorHost = import.meta.env.VITE_FIREBASE_EMULATOR_HOST;
if (emulatorHost) {
  connectAuthEmulator(auth, `http://${emulatorHost}`, { disableWarnings: true });
}

export const googleProvider = new GoogleAuthProvider();
export const microsoftProvider = new OAuthProvider('microsoft.com');

// Cached Firebase ID token for synchronous use in the API handler.
// Kept fresh by onIdTokenChanged, which fires on sign-in, sign-out, and
// automatic token refresh (~every 55 minutes).
let _cachedToken: string | null = null;

export function getFirebaseToken(): string {
  return _cachedToken ?? '';
}

export function primeFirebaseToken(token: string): void {
  _cachedToken = token;
}

onIdTokenChanged(auth, async firebaseUser => {
  if (firebaseUser) {
    _cachedToken = await firebaseUser.getIdToken();
  } else {
    _cachedToken = null;
  }
});
